// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container___mTorl","spinner":"styles-module__spinner___q4Lm4","loader-spinner":"styles-module__loader-spinner____zhsp"};